import React from 'react'
import "../styles/ActorInfoSection.css"

const ActorInfoSection = ({actorName}) => {
  return (
    <p className="actor-name">{actorName}</p>
  )
}

export default ActorInfoSection